import { ApiPath } from "enums";
import { Get, Post } from "utils";

export const getCampaigns = async () => {
  const res = await Get(ApiPath.SurveyCampaign);
  return res.data;
};

export const createCampaign = async ({
  description,
  campaignCode,
  campaignDate,
  status = "active",
  endDate,
  location,
  surveyQuestionDocument,
}) => {
  const formData = new FormData();

  formData.append("description", description);
  formData.append("campaignCode", campaignCode);
  formData.append("campaignDate", campaignDate);
  formData.append("status", status);
  formData.append("endDate", endDate);
  formData.append("location", location);

  if (surveyQuestionDocument) {
    formData.append("surveyQuestionDocument", surveyQuestionDocument);
  }

  const res = await Post(ApiPath.SurveyCampaign, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return res.data;
};

export const endCampaign = async ({ campaignCode }) => {
  const res = await Post(`${ApiPath.SurveyCampaign}/${campaignCode}/end`);
  return res.data;
};
